function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4141",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1",
  d: "M15.556 1.415L1.414 15.557"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 231",
  d: "M15.556 15.557L1.414 1.415"
}));

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.971,
    height: 16.971,
    viewBox: "0 0 16.971 16.971"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi45NzEiIGhlaWdodD0iMTYuOTcxIiB2aWV3Qm94PSIwIDAgMTYuOTcxIDE2Ljk3MSI+CiAgPGcgaWQ9Ikdyb3VwXzQxNDEiIGRhdGEtbmFtZT0iR3JvdXAgNDE0MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI1My44NTIgMjE1LjY2OCkgcm90YXRlKC00NSkiPgogICAgPGxpbmUgaWQ9IkxpbmVfMSIgZGF0YS1uYW1lPSJMaW5lIDEiIHgxPSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzIyIDM5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8yMzEiIGRhdGEtbmFtZT0iUGF0aCAyMzEiIGQ9Ik0yMCwwSDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMiAyOSkgcm90YXRlKDkwKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgClose as ReactComponent };